export default "__VITE_ASSET__XetCzoxv__"